<template>
  <div class="hello">
    <div style="text-align: left;" :style="{'margin-left': infoLeft + 'px'}" ref="info">
      <EditLabel class="editLabel" :text="title" @edited="titleEdited" tool-tip-disable/>
      <el-tag style="color: #8a8787; " size="small">{{ index_Sum }}</el-tag>
      <el-tag style="color: #8a8787; " size="small">{{ lastModify }}</el-tag>
      <el-tag v-if="mode === Mode.IMAGE" style="color: #8a8787; " size="small">Preload:{{ preloadCnt }}
        <el-icon v-if="isPreloaded">
          <Check/>
        </el-icon>
        <el-icon v-else>
          <Loading/>
        </el-icon>
      </el-tag>
    </div>
    <el-switch
        v-model="mode"
        size="large"
        active-text="video"
        active-value="video"
        inactive-value="image"
        inactive-text="image"
        inline-prompt
        style="position: fixed;top: 8px;right: 8px"
        @change="getNewList"
    />
    <div style="display: flex; align-items: center; justify-content: center"><!--实现水平布局-->
      <div style="/*width: 85%;*/margin: auto;padding: 5px 10px 2px 10px;" :style="{height: contentH + 'px'}"
           ref="contentWrap">
        <template v-if="mode === Mode.VIDEO">
          <video style="/*width: 100%;*/height: 100%;aspect-ratio: 16/9;box-shadow:0 0 15px #242526;" controls
                 ref="player" autoplay
                 preload="auto" volume="0.5"
                 @ended="switchToNext"> <!--@loadeddata="window.scrollTo(0, pageYScroll)" 必须得在加载完成侯滚动 否则dom未更新无效-->
            <source :src="src" type="video/mp4">
          </video>
        </template>
        <template v-else>
          <el-image :src="src" fit="scale-down" ref="imgViewer" v-loading="isLoading"
                    style="/*width: 100%;*/height: 100%;aspect-ratio: 16/9;filter: drop-shadow(0px 0px 15px rgba(38,36,36,0.5))">
            <template #placeholder>
              <span style="font-size: 32pt">cls正在拼命加载中...<br>（指的是买一个带宽高点的服务器）</span>
            </template>
          </el-image>
        </template>
      </div>
      <el-button style="right: 0;position: absolute; height: 200px" plain @click="switchToNext" :disabled="isLoading"
                 onfocus="this.blur()"> <!--阻止按钮获得焦点 这个this是DOM元素 与vue无关-->
        <el-icon>
          <ArrowRightBold/>
        </el-icon>
      </el-button>
    </div>
  </div>
</template>

<script>
import axiosIns from "@/utils/axiosInstance";
import * as _ from "@/utils/tool"
import {ElMessage} from "element-plus";
import EditLabel from "@/components/EditLabel.vue";

const Mode = { //enum 需要在data中声明
  VIDEO: "video",
  IMAGE: "image"
}
let vImage = new Image() //全局对象 防止过多new 导致内存泄漏(有GC吧问题不大)

export default {
  name: 'Viewer',
  components: {EditLabel},
  // inject: ['baseUrl'],
  data() {
    return {
      src: '',
      title: 'Text', //占位 防止高度计算错误
      list: [],
      index: 0,
      window,
      infoLeft: 0,
      Mode,
      mode: Mode.IMAGE,
      contentH: 0,
      isPreloaded: false,
      preloadCnt: 1,
      preloadLen: 30, //预载图片数量
      isLoading: false
    }
  },
  methods: {
    titleEdited(newTitle) {
      this.title = newTitle
      let obj = this.list[this.index]
      let fullName = this.list[this.index].name
      let suffix = _.getSuffix(fullName)
      let newName = this.title + suffix
      if (newName !== fullName) {
        axiosIns.post('/rename', {
          oldName: fullName,
          newName: newName
        }).then((res) => {
          if (!res.data.state) throw new Error("rename failed")
          obj.name = newName //引用 即便shuffle也没事 虽然无法检测arr整体重新赋值(axios) 但是问题不大
          ElMessage.success('Rename Success')
        }).catch((error) => {
          if (obj === this.list[this.index]) //确保index没变
            this.title = _.getFileName(fullName) //改回来
          ElMessage.error('Oops,' + error)
        })
      }
    },
    switchToNext() {
      this.index++
      if (this.index === this.list.length) {
        this.index = 0
        this.getNewList()
        return
      }
      if (this.mode === Mode.VIDEO) {
        this.setVideoByIndex(this.index)
        this.$refs.player.autoplay = true
      } else {
        this.setImageByIndex(this.index)
      }
    },
    setVideoByIndex(i) {
      this.index = i
      this.setVideoSrc(this.list[i].uri, this.list[i].name)
    },
    setVideoSrc(uri, name) {
      this.title = _.getFileName(name)
      this.src = uri
      this.$refs.player.load() //否则不加载新源
    },
    setImageByIndex(i) {
      this.index = i
      this.setImageSrc(this.list[i].uri, this.list[i].name)
      if (this.isPreloaded) { //切换图片后重新计算预载index
        this.isPreloaded = false
        if (this.index === 0) this.preloadCnt = 1 //从第二张开始预载
        this.preloadImages(this.preloadCnt)
      }
    },
    setImageSrc(uri, name) {
      this.title = _.getFileName(name)
      this.src = uri
    },
    getVideoList() {
      axiosIns.get("/getVideoList").then(res => {
        this.list = res.data["videoList"]
        console.assert(this.list, "list == null")
        _.shuffle(this.list)
        this.setVideoByIndex(this.index)
      })
    },
    getImageList() {
      this.isLoading = true
      axiosIns.get("/getImageList").then(res => {
        this.isLoading = false
        this.list = res.data["imageList"]
        console.assert(this.list, "list == null")
        _.shuffle(this.list)
        this.setImageByIndex(this.index)
        this.preloadImages(0)
      })
    },
    getNewList() {
      this.index = 0 //important
      if (this.mode === Mode.VIDEO) //切换为Image后，已请求的视频会继续缓冲一会儿，咋办捏 虽然用了v-if导致player消失了 没法用pause
        this.getVideoList()
      else
        this.getImageList()
    },
    preloadImages(i) { //递归实现串行预加载
      if (i >= this.list.length || i > this.index + this.preloadLen) { //预载长度限制，防止内存爆炸
        this.isPreloaded = true
        return
      }
      vImage.src = this.list[i].uri //采用特性：加载过的资源会缓存 来实现预载
      const loadNext = () => {
        // console.log('Preload:', i)
        this.preloadCnt = i + 1
        if (this.mode !== Mode.IMAGE) {
          console.log('#stop image preload')
        } else
          this.preloadImages(Math.max(i + 1, this.index + 1)) //递归调用 确保按顺序预载 确保按顺序加载完毕 防止多请求相互阻塞
        //max：从用户当前index开始向后预载，确保体验
      }
      vImage.onload = loadNext
      vImage.onerror = () => {
        console.log('#preloadError:', i)
        loadNext()
      }
    },
    updateLayout() {
      console.log("updateLayout")
      const ratio = 16 / 9 //eval(this.$refs.imgViewer.$el.style.aspectRatio)要考虑video
      const maxWidth = document.documentElement.clientWidth * 0.90
      this.contentH = (document.documentElement.clientHeight
          - this.$refs.info.offsetHeight
          - document.getElementById("footer").offsetHeight
          - parseFloat(this.$refs.contentWrap.style.getPropertyValue('padding-bottom'))
          - parseFloat(this.$refs.contentWrap.style.getPropertyValue('padding-top'))
          - 10); //余量
      this.contentH = Math.min(this.contentH, maxWidth / ratio)
      this.$nextTick(() => { //等待上述contentH渲染
        if (this.mode === Mode.VIDEO) //获取video的left值 用于对齐文本
          this.infoLeft = this.$refs.player.offsetLeft
        else
          this.infoLeft = this.$refs.imgViewer.$el.offsetLeft
      })
    }
  },
  computed: {
    index_Sum() {
      return (this.index + 1) + ' / ' + this.list.length
    },
    lastModify() {
      let obj = this.list[this.index]
      if (obj && obj['lastModify'])
        return obj['lastModify']
      return 'time'
    }
  },
  created() {
    this.$nextTick(this.updateLayout) //等待渲染完毕
    addEventListener('resize', this.updateLayout)
    this.getNewList()
  },
  unmounted() {
    removeEventListener('resize', this.updateLayout) //需要手动解除监听
  }
}
</script>
<style scoped>
.editLabel {
  font-size: 17pt;
  font-weight: bold;
}
</style>